import MarcaCreate from './MarcaCreate'
export {MarcaCreate}
export default MarcaCreate
